<section class="mat-typography">
  <app-header-bar></app-header-bar>
  <app-side-nav></app-side-nav>
</section>
